import { MANAGED_KEY } from './constants';

export const MANAGED_DATA = {
  [MANAGED_KEY.empty]: {
    id: MANAGED_KEY.empty,
    name: 'Передайте управление пользователю',
    attrs: {
      color: 'ui-warning',
      get textColor() {
        return `${this.color}--text text--darken-1`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
  [MANAGED_KEY.manager]: {
    id: MANAGED_KEY.manager,
    name: 'Управляется пользователем',
    attrs: {
      color: 'ui-success',
      get textColor() {
        return `${this.color}--text`;
      },
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
    },
  },
};

export default {
  MANAGED_DATA,
};
